import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';
import { Rodeo } from '../../../../../model/rodeo';
import { ProgressionSource } from '../../../../../model/progression-source';

@Component({
    selector: 'progression-source',
    templateUrl: 'progression-source.html'
})
export class ProgressionSourceModal {
    rodeo: Rodeo;
    progressionSource: ProgressionSource;
    editing: boolean = true;

    constructor(navParams: NavParams, private viewController: ViewController) {
        this.rodeo = navParams.get('rodeo');
        this.progressionSource = navParams.get('progressionSource');

        if (!this.progressionSource) {
            this.progressionSource = new ProgressionSource();
            this.editing = false;
        } else {
            this.progressionSource.payoutConfig = null;
            this.progressionSource = JSON.parse(JSON.stringify(this.progressionSource));
        }
    }

    create() {
        this.viewController.dismiss(this.progressionSource);
    }

    remove() {
        this.viewController.dismiss(0);
    }

    cancel() {
        this.viewController.dismiss(null);
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/settings/progressions/progression-source.ts